import api from '@/libs/axios'
import { PaginatedList } from '@/api/models/common/paginatedList';
import { DemandeAccessPlateformeBeneficiaire } from '@/api/models/accesPlateformeBeneficiaires/demandeAccessPlateformeBeneficiaire';

const resource = 'demandeAcces'

export default class PtfBeneficiaireDemandeAccesResource {

  public async search(
    pageNumber: number,
    pageSize: number,
    orderBy: string,
    orderByDescending: boolean,
    includeTraitees: boolean
  ) : Promise<PaginatedList<DemandeAccessPlateformeBeneficiaire>> {

    const queryParams = new URLSearchParams({
      pageNumber: pageNumber.toString(),
      pageSize: pageSize.toString(),
      orderBy: orderBy,
      orderByDescending: orderByDescending.toString(),
      includeTraitees: includeTraitees.toString()
    });

    const response = await api.get<PaginatedList<DemandeAccessPlateformeBeneficiaire>>(`${resource}?${queryParams.toString()}`)
    return response.data
  }

  public async update(
    demandeId: string,
    accepte: boolean,
    commentaire?: string
  ) : Promise<void> {
    await api.put<void>(`${resource}/${demandeId}`, {
      accepte: accepte,
      commentaire: commentaire
    })
  }

}